<template>
  <div class="consult-container">
    <div class="table-container">
      <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="申请人" align="center">
        </el-table-column>
        <el-table-column prop="reason" label="申请接入事由" align="center">
        </el-table-column>
        <el-table-column prop="databaseType" label="数据库类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.databaseType === 1">mysql</span>
            <span v-else-if="scope.row.databaseType === 2">postgresql</span>
            <span v-else-if="scope.row.databaseType === 3">oracle</span>
            <span v-else-if="scope.row.databaseType === 4">sqlserver</span>
            <span v-else-if="scope.row.databaseType === 5">db2</span>
            <span v-else-if="scope.row.databaseType === 6">redis</span>
            <span v-else-if="scope.row.databaseType === 7">sybase</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="申请时间" align="center" :formatter="dateFormat">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.serverStatus === 1">审核中</span>
            <span v-else-if="scope.row.serverStatus === 2">已驳回</span>
            <span v-else-if="scope.row.serverStatus === 3">（已接入）审核通过</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button type="text" size="small" @click="handleReviewClick(scope.row)">审核</el-button>
            <el-button type="text" size="small" @click="handleSetting(scope.row)">配置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核/配置功能 -->
    <el-drawer :title="drawerType === 'review' ? '审核' : '配置'" :visible.sync="drawer" direction="rtl"
      :before-close="handleClose">
      <el-form ref="form" :model="drawerForm" label-width="80px" v-if="drawerType === 'review'">
        <el-form-item label="审核结果">
          <el-radio-group v-model="drawerForm.result">
            <el-radio :label="0">通过</el-radio>
            <el-radio :label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="drawerForm.result === 1">
          <el-input type="textarea" v-model="drawerForm.reason" placeholder="请输入原因"></el-input>
        </el-form-item>
        <el-form-item label="连接地址">
          <el-input v-model="drawerForm.url" placeholder="请输入连接地址"></el-input>
        </el-form-item>
        <el-form-item label="端口号">
          <el-input v-model="drawerForm.port" placeholder="请输入端口号"></el-input>
        </el-form-item>
        <el-form-item label="数据库名">
          <el-input v-model="drawerForm.name" placeholder="请输入数据库名"></el-input>
        </el-form-item>
        <el-form-item label="账户名称">
          <el-input v-model="drawerForm.userName" placeholder="请输入账户名称"></el-input>
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="drawerForm.pwd" placeholder="请输入登录密码"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" :model="settingForm" label-width="100px" v-else>
        <el-form-item label="连接地址">
          <el-input v-model="settingForm.url" placeholder="请输入连接地址"></el-input>
        </el-form-item>
        <el-form-item label="端口号">
          <el-input v-model="settingForm.port" placeholder="请输入端口号"></el-input>
        </el-form-item>
        <el-form-item label="数据库名">
          <el-input v-model="settingForm.name" placeholder="请输入数据库名"></el-input>
        </el-form-item>
        <el-form-item label="账户名称">
          <el-input v-model="settingForm.userName" placeholder="请输入账户名称"></el-input>
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="settingForm.pwd" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="数据库大小">
          <el-input v-model="settingForm.spaceSize" placeholder="请输入数据库大小"></el-input>
        </el-form-item>
        <el-form-item label="连接池数">
          <el-input v-model="settingForm.pool" placeholder="请输入连接池数"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="drawerType === 'review' ? submitReview() : submitSetting()"
          :loading="loading">{{
            loading ? '提交中 ...' : '确 定' }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getDatabaseList, getDatabaseSetting } from '@/api/resourcesManagement'
import { getResourceReview } from '@/api/operationsManagement'
import moment from 'moment';
export default {
  name: 'AdminStaticsMsqManagement',
  data() {
    return {
      tableLoading: false,
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: 'total, prev, pager, next, jumper', // 分页布局
      },
      tableData: [],
      drawer: false,
      drawerType: 'review',
      drawerForm: {
        result: 0,
        url: '',
        reason: '',
        port: '',
        name: '',
        userName: '',
        pwd: '',
      },
      settingForm: {
        url: '',
        port: '',
        name: '',
        userName: '',
        pwd: '',
        pool: '',
        spaceSize: '',
      },
      record: {},
    };
  },

  mounted() {
    this.loadData()
  },

  methods: {
    cancelForm() {
      this.drawer = false
    },
    // 时间转换
    dateFormat(row) {
      return moment(row.createDate).format('YYYY-MM-DD HH:mm:ss');
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleClick(row) {
      console.log(row);
    },
    onSubmit() {
      this.loadData()
    },
    handleReviewClick(row) {
      this.drawer = true
      this.drawerType = 'review'
      this.record = row
    },
    handleSetting(row) {
      this.drawer = true
      this.drawerType = 'setting'
      this.record = row
    },
    // 审核-确定
    async submitReview() {
      const params = {
        id: this.record.id,
        memberId: this.record.memberId,
        result: this.drawerForm.result,
        reviewType: 8,
      }
      if (this.drawerForm.result === 1) {
        params.reason = this.drawerForm.reason
      }
      await getResourceReview({
        ...params,
        url: this.drawerForm.url,
        port: this.drawerForm.port,
        name: this.drawerForm.name,
        userName: this.drawerForm.userName,
        pwd: this.drawerForm.pwd,
      }).then(() => {
        this.$message.success('审核成功')
        this.drawer = false
        this.record = {}
        this.loadData()
      })
    },
    // 设置-确定
    async submitSetting() {
      await getDatabaseSetting({
        id: this.record.id,
        databaseType: this.record.databaseType,
        url: this.settingForm.url,
        port: Number(this.settingForm.port),
        name: this.settingForm.name,
        userName: this.settingForm.userName,
        pwd: this.settingForm.pwd,
        pool: Number(this.settingForm.pool),
        spaceSize: Number(this.settingForm.spaceSize),
      }).then(() => {
        this.$message.success('配置成功')
        this.drawer = false
        this.record = {}
        this.loadData()
      })
    },
    async loadData() {
      this.tableLoading = true
      await getDatabaseList({
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        this.tableLoading = false
        this.tableData = res.data.content
        this.pagination.total = res.data.totalElements
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .table-container {
    padding: 0 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }

  .drawer-footer {
    text-align: center;
  }
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>